









































































































































































































































































































































































































































import { Component } from "vue-property-decorator";
import axios from "axios";
import HacoBase from "../HacoBase";
import { getCalcTypes } from "../model/CalcType";
import { PaperColorCost, PaperCost } from "../model/Cost";
import { PaperType } from "../model/PaperType";
import { PaperColor } from "../model/PaperColor";
interface DetailData {
  id: number;
  itemPaperSizeName: string;
  width: number;
  dimension: number;
  unprintableWidth: number;
  unprintableDimension: number;
  calcType: StringConstructor;
  paperCosts: object[];
  paperColorCosts: object[];
  paperFixedCosts: object[];
}
@Component
export default class PaperSizeComp extends HacoBase {
  editData: any = {};
  detailData: any = null;
  $debugServer!: string;
  locale = "en";
  paperCosts: any[] = [];
  editable = -2;
  saved = true;
  calcTypes = getCalcTypes();
  calcTypeKey = "hacoplay";
  paperTypeHacoplay: any = {};
  paperTypePaperBug: any = {};
  selectColorPaper = 0;
  selectPaperCost: any[] = [];

  mounted(): void {
    this.locale = this.$i18n.locale;
    this.paperCosts = [];
    this.loadListData();
  }

  chooseTab(id: number): void {
    this.selectColorPaper = id;
    this.detailData.paperSize.paperColorCosts[
      this.selectColorPaper
    ] = Object.values(
      this.detailData.paperSize.paperColorCosts[this.selectColorPaper]
    );
  }

  addCell(arr: PaperColorCost[][]): void {
    let newItemList: PaperColorCost[] = arr.slice(-1)[0];
    if (newItemList && newItemList.length > 0) {
      newItemList = newItemList.map(list => ({ ...list }));
      const copyMap = newItemList.map(newItem => {
        newItem.sheetFrom = Math.floor(newItem.sheetFrom) + 1;
        newItem.sheetTo = -1;
        if (newItem.id) {
          delete newItem.id;
        }
        return newItem;
      });
      arr.push(copyMap);
    }
  }

  checkInputKeys(e: KeyboardEvent, listMode: number | undefined): void {
    if (e.ctrlKey === true && e.key === "Enter") {
      if (listMode) {
        this.openEditPage(listMode, false);
      } else {
        this.onSubmit();
      }
    } else if (e.key === "Escape") {
      this.afterSaving();
    }
  }

  checkVariance(item: any): boolean {
    if (
      (this.editable !== item.id && this.saved === false) ||
      item.itemPaperSizeName === "" ||
      item.width === null ||
      item.dimension === null ||
      item.unprintableWidth === null ||
      item.unprintableDimension === null ||
      item.width === "" ||
      item.dimension === "" ||
      item.unprintableWidth === "" ||
      item.unprintableDimension === "" ||
      (this.saved === false && item.id !== -1)
    ) {
      return false;
    } else {
      return true;
    }
  }

  loadListData(): void {
    const url = this.$debugServer + "/api/v1_inner/paper_size";
    this.paperCosts.length = 0;
    const params: object = this.setAxiosParams(url, "get");
    // データ取ってくる
    axios(params)
      .then((response: any): void => {
        this.editData = response.data;
        this.paperTypeHacoplay = this.editData.paperType.filter(
          (paperType: any) => !paperType.isPaperBug
        );
        this.paperTypePaperBug = this.editData.paperType.filter(
          (paperType: any) => paperType.isPaperBug
        );
        // this.editData.paperType = this.paperTypeHacoplay;
        Object.keys(this.editData.paperSize.paperCosts).forEach(
          (k: string): void => {
            this.paperCosts.push(this.editData.paperSize.paperCosts[k]);
          }
        );
      })
      .catch((error: any): void => {
        console.log("[error]", error.response);
        this.toLoginPage(error);
      });
  }

  getLineColorData(): any[] | null {
    return this.detailData.paperSize.paperColorCosts[this.selectColorPaper]
      ? this.detailData.paperSize.paperColorCosts[this.selectColorPaper]
      : null;
  }
  getColorCostData(costs: any[], colorId: number): any {
    if (costs) {
      return Object.values(costs).find(
        (cost: PaperColorCost) => cost.paperColorId === colorId
      );
    }
  }

  getCostData(paperTypeId: number, itemPaperSizeId: number): any {
    let data = null;
    for (let i = 0; i < this.paperCosts.length; i++) {
      data = this.paperCosts[i].find(
        (cost: PaperCost) =>
          Number(cost.paperTypeId) === paperTypeId &&
          Number(cost.itemPaperSizeId) === itemPaperSizeId
      );
      if (data) break;
    }
    return data;
  }

  changeCalcType(calcType: string): void {
    // if (this.editData && this.editData.paperType) {
    //   this.editData.paperType =
    //     calcType === "hacoplay"
    //       ? this.paperTypeHacoplay
    //       : this.paperTypePaperBug;
    // }
    if (
      this.detailData &&
      this.detailData.paperSize &&
      this.detailData.paperSize.calcType
    ) {
      this.detailData.paperSize.calcType = calcType;
    }
  }

  /** PaperTypeリストの高さ取得して揃える */
  adjustListHeight(): void {
    this.$nextTick(() => {
      const paperTypes: HTMLCollection = document.getElementsByClassName(
        "paperType"
      ) as HTMLCollection;
      const fixedCosts: HTMLCollection = document.getElementsByClassName(
        "fixedCost"
      ) as HTMLCollection;
      /** paperCostのみUL */
      const paperCosts: HTMLCollection = document.getElementsByClassName(
        "paperCost"
      ) as HTMLCollection;

      let paperTypeLi: HTMLLIElement;
      let fixedCostLi: HTMLLIElement;
      let paperCostLi: HTMLLIElement;
      const boxHeights: number[] = [];
      Object.keys(paperTypes).forEach((k: string, i: number): void => {
        paperTypeLi = paperTypes[i] as HTMLLIElement;
        const offsetHeight: number = paperTypeLi.offsetHeight;
        fixedCostLi = fixedCosts[i] as HTMLLIElement;
        fixedCostLi.style.height = offsetHeight + "px";
        boxHeights[i] = offsetHeight;
      });

      Object.keys(paperCosts).forEach((k: string, i: number): void => {
        const ul: HTMLUListElement = paperCosts[i] as HTMLUListElement;
        Object.keys(ul.childNodes).forEach((j: string, l: number): void => {
          paperCostLi = ul.childNodes[l] as HTMLLIElement;
          paperCostLi.style.height = boxHeights[l] + "px";
        });
      });
      const paperType: HTMLUListElement = document.getElementById(
        "paperType"
      ) as HTMLUListElement;
      const paperTypeHead: HTMLLIElement = document.getElementById(
        "paperTypeHead"
      ) as HTMLLIElement;
      if (paperTypeHead && paperTypeHead.style) {
        paperTypeHead.style.width = paperType.offsetWidth - 1 + "px";
      }
    });
  }

  getPaperColorObject(): {
    [key: string]: { [key: string]: PaperColorCost[] };
  } {
    return this.editData.paperType
      .filter((paperType: PaperType) => paperType.hasPaperColor)
      .map((oneData: PaperType) => {
        const colorCosts: PaperColorCost[] = [];

        this.editData.paperColor
          .filter(
            (paperColorType: PaperColor) =>
              paperColorType.paperTypeId === oneData.id
          )
          .map((filteredColorType: PaperColor) => {
            const colorCost = new PaperColorCost();
            colorCost.paperTypeId = filteredColorType.paperTypeId;
            colorCost.paperColorId = filteredColorType.colorId;
            colorCost.sheetFrom = 1;
            colorCost.sheetTo = -1;
            colorCosts.push(colorCost);
          });
        return colorCosts;
      })
      .reduce(
        (
          newValue: { [key: string]: { [key: string]: PaperColorCost[] } },
          listlist: PaperColorCost[]
        ) => {
          //console.log(listlist);
          if (!newValue[listlist[0].paperTypeId]) {
            newValue[listlist[0].paperTypeId] = { 0: [] };
          }
          newValue[listlist[0].paperTypeId][0] = listlist;
          return newValue;
        },
        {}
      );
  }

  addPaperSize(): void {
    this.detailData = null;
    this.saved = false;
    interface PaperSizeItem {
      id: number;
      itemPaperSizeName: string;
      width: number | null;
      dimension: number | null;
      unprintableWidth: number | null;
      unprintableDimension: number | null;
      calcType: string;
      scenariosCount: number;
    }
    const newItem: PaperSizeItem = {
      id: -1,
      itemPaperSizeName: "",
      width: null,
      dimension: null,
      unprintableWidth: null,
      unprintableDimension: null,
      calcType: "hacoplay",
      scenariosCount: 0
    };
    const paperData: any = this.editData.paperSize;
    paperData.paperSizeList.push(newItem);
    const paperCost: any[] = [];
    Object.keys(this.editData.paperType).forEach((k: string, i: number) => {
      const newPaperCost: object = {
        paperTypeId: this.editData.paperType[i].id,
        itemPaperSizeId: -1,
        cost: null
      };
      paperCost[i] = newPaperCost;
    });
    this.paperCosts.push(paperCost);
    this.editable = -1;
    this.scrollToResult("paperSizeList_-1");
    this.focusItem("itemPaperSizeName");
  }

  focusItem(className: string): void {
    this.$nextTick((): void => {
      const newItem: HTMLInputElement = document.getElementsByClassName(
        className
      )[0] as HTMLInputElement;
      newItem.select();
    });
  }

  openEditPage(id: number, noScrolling: boolean): void {
    /** 新規の場合 */
    this.editable = id;
    this.saved = false;
    if (id === -1) {
      const newestData: any = this.editData.paperSize.paperSizeList;
      const len = newestData.length - 1;

      this.detailData = {
        paperSize: {
          itemPaperSizeName: newestData[len].itemPaperSizeName,
          width: newestData[len].width,
          dimension: newestData[len].dimension,
          unprintableWidth: newestData[len].unprintableWidth,
          unprintableDimension: newestData[len].unprintableDimension,
          paperCosts: this.paperCosts[len],
          calcType: newestData[len].calcType,
          paperColorCosts: this.getPaperColorObject(),
          paperFixedCosts: this.editData.paperSize.paperFixedCost
        }
      };
    } else {
      this.detailData = this.setDetailData(id);
      // console.log(this.detailData.paperSize.calcType);
    }
    if (this.detailData.paperSize.calcType === "paperBug") {
      const firstTabPaperType = this.editData.paperType.find(
        (ptOne: PaperType) => ptOne.hasPaperColor
      );
      if (firstTabPaperType) {
        this.chooseTab(firstTabPaperType.id);
      }
    }
    this.adjustListHeight();
    if (noScrolling === false || id === -1) {
      this.scrollToResult("paper_" + id, 100);
      this.focusItem("oneCost");
    } else {
      this.scrollToResult("paperSizeList_" + id, 150);
      this.focusItem("itemPaperSizeName");
    }
  }

  getDetailData(id: number): void {
    const url = this.$debugServer + "/api/v1_inner/paper_size/" + id + "/edit";
    // データ取ってくる
    const params: object = this.setAxiosParams(url, "get");
    // データ取ってくる
    axios(params)
      .then((response: any): void => {
        this.detailData = response.data;
        this.adjustListHeight();
        this.scrollToResult("paperCosts");
      })
      .catch((error: any): void => {
        console.log("[error]", error.response);
        this.toLoginPage(error);
      });
  }

  setDetailData(id: number): object {
    let detailData!: DetailData;
    for (const item of this.editData.paperSize.paperSizeList) {
      if (id === item.id) {
        let paperColorCosts = [];
        if (this.editData.paperSize.paperColorCosts[id]) {
          paperColorCosts = this.editData.paperSize.paperColorCosts[id];
          //console.log(paperColorCosts);
        }
        detailData = {
          id: id,
          itemPaperSizeName: item.itemPaperSizeName,
          width: item.width,
          dimension: item.dimension,
          unprintableWidth: item.unprintableWidth,
          unprintableDimension: item.unprintableDimension,
          paperCosts: this.editData.paperSize.paperCosts[id],
          paperFixedCosts: this.editData.paperSize.paperFixedCosts,
          paperColorCosts,
          calcType: item.calcType
        };
        //this.changeCalcType(item.calcType);
        break;
      }
    }
    return { paperSize: detailData };
  }

  onSubmit(): void {
    const mes = this.$t("message.editCommon.saveConfirmation");
    const confirmation: boolean = confirm(mes as string);
    if (confirmation === false) {
      return;
    }

    const saveData: any =
      this.detailData.paperSize.id === undefined
        ? this.detailData
        : this.setDetailData(this.detailData.paperSize.id);
    if (saveData.paperSize.paperColorCosts) {
      const datas: { [key: string]: { [key: string]: PaperColorCost[] } } =
        saveData.paperSize.paperColorCosts;
      Object.keys(datas).map(key => {
        const data = datas[key];
        const keysList = Object.keys(data);
        for (let i = 0; i < keysList.length; i++) {
          let valueTo = -1;
          if (keysList[i + 1]) {
            const toData = datas[key][keysList[i + 1]];
            valueTo = toData[0] ? toData[0].sheetFrom - 1 : -1;
          }
          const list = datas[key][keysList[i]];
          const firstFrom = list[0] ? list[0].sheetFrom : -1;
          list.map(item => {
            item.sheetFrom = firstFrom;
            item.sheetTo = valueTo;
            return item;
          });
        }
      });
    }

    const errorItems = this.checkColorSheetValue(
      saveData.paperSize.paperColorCosts
    );
    if (errorItems.length) {
      errorItems.forEach(errorItem => {
        const sheetError: HTMLInputElement = document.getElementsByName(
          `checkColorSheetValue-${errorItem.paperTypeId}-${errorItem.lineNo}`
        )[0] as HTMLInputElement;
        if (sheetError) {
          sheetError.setCustomValidity(
            this.$t("message.editCommon.error.invalidSheetValue") as string
          );
        }
      });
      this.$emit(
        "putErrorText",
        this.$t("message.editCommon.error.invalidSheetValue")
      );
      return;
    }

    /** 入力データエラーチェック */
    let i = 0;
    let costError = false;
    for (const item of saveData.paperSize.paperCosts) {
      if (item.cost === "") {
        costError = true;
        const numberEle: HTMLInputElement = document.getElementsByClassName(
          "oneCost"
        )[i] as HTMLInputElement;
        numberEle.setCustomValidity(
          this.$t("message.editCommon.error.invalidCost") as string
        );
      }
      i += 1 | 0;
    }
    if (costError === true) {
      this.$emit(
        "putErrorText",
        this.$t("message.editCommon.error.invalidCost")
      );
      console.log("[Error] cost");
      return;
    }

    /** 表記の揺れ対策 */
    interface CategoryObj {
      category: string;
      backTo: string;
      dataName: string;
    }
    const categoryObj: CategoryObj = {
      category: "paper_size",
      backTo: "PaperSize",
      dataName: "paperSize"
    };
    const id: number =
      saveData.paperSize.id === undefined
        ? -1
        : parseInt(saveData.paperSize.id, 10);
    this.sendEditData(id, saveData, categoryObj, false, this.afterSaving);
  }

  afterSaving(): void {
    this.detailData = null;
    this.editable = -2;
    this.saved = true;
    this.loadListData();
  }

  deleteItem(id: string) {
    const confirmation: boolean = confirm(
      this.$t("message.editCommon.deleteConfirmation") as string
    );
    if (confirmation === false) {
      return;
    }
    const url = this.$debugServer + "/api/v1_inner/paper_size/" + id;
    const params: object = this.setAxiosParams(url, "delete");

    axios(params)
      .then((response: any): void => {
        if (response.data === 1) {
          /** 保存完了したら */
          this.detailData = null;
          this.loadListData();
        }
      })
      .catch((error: any): void => {
        console.log("[Delete Error]", error);
        Object.keys(error).forEach((k: string) => {
          console.log(k, error[k]);
        });
        this.toLoginPage(error);
      });
  }

  checkColorSheetValue(paperColorCostObject: {
    [key: string]: { [key: string]: PaperColorCost[] };
  }): PaperColorCost[] {
    const errors: PaperColorCost[] = [];
    Object.values(paperColorCostObject).forEach(paperCostObject2 => {
      Object.values(paperCostObject2).forEach((paperCost, index, array) => {
        if (array[index + 1] && array[index + 1][0]) {
          const next = array[index + 1][0];
          if (Number(paperCost[0].sheetFrom) >= Number(next.sheetFrom)) {
            next.lineNo = index + 1;
            errors.push(next);
          }
        }
      });
    });
    return errors;
    // if(this.detailData.paperColorCosts && this.detailData.paperColorCosts)
  }
}
